import React, { Component, Fragment } from 'react';
import { translate, Trans } from "react-i18next";
import Scrollbars from 'react-custom-scrollbars';
import Modal from 'react-modal';
import { _addNotification, _addNotificationError, getLoginParent } from '../../../server/util';
import { numberOnly } from '../../../server/util.js'
import { MealBenefitEligibilityPrograms } from './../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal';
import { personType, IncomFreqency, personModal, childIncomeTypeList, incomeModal, declinedReasonList } from '../../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import { get, postWithHeaders, patch } from "../../../server/actions";
import moment from 'moment';
import './schoolMealProgramView.css';
import { PropagateLoader } from 'react-spinners';
import IncompleteAppDetails from './incompleteAppDetails';
import _ from 'lodash';
const hideInCompleteList = [4];
const yearlyIncome = (freq, amount) => {
    return parseInt((freq || 0) === '' ? 0 : (freq || 0)) * parseFloat((amount || 0) === '' ? 0 : (amount || 0))
}
const incompleteInfo = require('./incompleteInfo.json');
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const reasonModalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
let loginUserInfo = {};
let districtId = '';
class SchoolMealProgramView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            appData: {},
            incompleteReasons: incompleteInfo,
            isStateChanged: false,
            modalIsOpen: false,
            incompleteModalIsOpen: false,
            cancelAppModalIsOpen: false,
            cancelReason: '',
            editNoteModalIsOpen: false,
            conformationModalIsOpen: false,
            pendingUpdateType: null,
            pendingUpdateData: null,
            editNote: ''
        }
        this.formatObject = this.formatObject.bind(this);
        this.onSubmitApp = this.onSubmitApp.bind(this);
        this.calculateTotal = this.calculateTotal.bind(this);
    }
    componentWillMount = () => {
        if (sessionStorage.getItem('ROLE') === 'ROLE_ADMIN') {
            loginUserInfo = JSON.parse((sessionStorage.getItem('loggedInUserInfo') || '') === '' ? {} : sessionStorage.getItem('loggedInUserInfo'))
            districtId = loginUserInfo.districtId;
        } else if (sessionStorage.getItem('ROLE') === 'ROLE_DISTRICT') {
            loginUserInfo = this.props.loggedUser;
            districtId = loginUserInfo.districtId;
            // districtId = JSON.parse(sessionStorage.getItem('loggedInUserDetails')).districtId;
        } else {

        }
        this.formatObject();

    }
    formatObject = () => {
        let lunchObj = JSON.parse(JSON.stringify(this.props.appData));
        lunchObj.person = []
        lunchObj.person = this.props.appData.householdAppInfo.filter((parent => {
            return parent.personType == personType.adult && parent.filledTheApplication === true
        })).map((parent) => {
            // Use email if it exists (even if empty string), otherwise fall back to contact.email only if email field was never set
            const email = parent.email !== undefined ? parent.email : ((parent.contact || {}).email || '');
            return {
                ...parent,
                email: email,
                isPrimaryParent: parent.isPrimaryParent !== undefined ? parent.isPrimaryParent : true,
                personType: personType.adult
            }
        });
        lunchObj.studentList = this.props.appData.householdAppInfo.filter((student) => {
            return student.personType === personType.student
        })
        lunchObj.childList = []
        lunchObj.childList = this.props.appData.householdAppInfo.filter((student) => {
            return student.personType === personType.child
        })
        lunchObj.adultList = [];
        lunchObj.adultList = this.props.appData.householdAppInfo.filter((student) => {
            return student.personType === personType.adult && student.filledTheApplication === false
        })
        lunchObj.assistancePrograms = []
        lunchObj.assistancePrograms = lunchObj.person[0].assistancePrograms;
        lunchObj.declinedReasonList = (lunchObj.declinedReasonList || []).length > 0 ? lunchObj.declinedReasonList : declinedReasonList.slice();
        lunchObj.declinedReasonList[0]['description'] = undefined;
        lunchObj.declinedReasonList[1]['description'] = undefined;
        lunchObj.incompleteReasonList = (lunchObj.incompleteReasonList || []).length > 0 ? lunchObj.incompleteReasonList : incompleteInfo
        this.setState({ appData: JSON.parse(JSON.stringify(lunchObj)) })
    }
    getFrequencyName = (freq) => {
        let frequency = IncomFreqency.find(inf => {
            return inf.value == freq;
        });
        return ((frequency || {}).text || '');
    }
    getAnnualIncome = (Income) => {
        let amount = 0.00;
        Income.map(inc => {
            amount = amount + (parseInt(inc.frequency) * parseFloat(inc.amount))
        });
        return amount;
    }
    userTotIncome = (Income) => {
        let amount = 0.00;
        Income.map(inc => {
            amount = amount + (parseFloat(inc.amount))
        });
        return amount;
    }

    calculateTotal = () => {
        let noOfHousehold = 0;
        let amount = 0.00;
        let _appData = this.state.appData;
        let income = []; let students = [];
        _appData.person.map(st => {
            students.push(st);
            if (st.income.length > 0) {
                const lst = st.income;
                income = [...income, ...lst];
            }
        });
        _appData.studentList.map((st) => {
            students.push(st);
            if (st.income.length > 0) {
                const lst = st.income;
                income = [...income, ...lst];
            }
        })
        _appData.childList.map(st => {
            students.push(st);
            if (st.income.length > 0) {
                const lst = st.income;
                income = [...income, ...lst];
            }
        });
        _appData.adultList.map(st => {
            students.push(st);
            if (st.income.length > 0) {
                const lst = st.income;
                income = [...income, ...lst];
            }
        });
        const freq = income.length > 0 ? income[0].frequency : 0;
        const res = income.every(inc => {
            return inc.frequency == freq;
        });

        noOfHousehold = students.length;

        students.map((student) => {
            amount = amount + (res ? this.userTotIncome(student.income) : this.getAnnualIncome(student.income));
        });

        return {
            totalAmount: amount,
            frequency: res ? this.getFrequencyName(freq) : 'annum',
            size: noOfHousehold
        };
    }

    getSystemDateTime = (date) => {
        const selectedDateTime = moment(date).set({
            hour: moment().get('hour'),
            minute: moment().get('minute'),
            second: moment().get('second')
        })
        let _datetime = moment.utc(selectedDateTime).format('YYYY-MM-DDTH:mm:ss');
        return _datetime + 'Z';
    }
    onSubmitApp = (e, action, appData, skipConfirmation) => {
        const { confirmingOfficialUserIds, loggedUser, autoDecisionEligibility, adverseActionProcedure, enableConfirmingOfficial } = this.props;
        let isError = false;
        const stateAppData = { ...appData };
        let headers = {
            'Content-Type': 'application/json'
        };
        let reqBody = JSON.parse(JSON.stringify(appData || this.state.appData || this.props.appData));
        let persons = [];
        appData.person.map((person, p) => {
            person.assistancePrograms = []
            appData.assistancePrograms.map((prog) => {
                if (!prog.isApplicable) {
                    prog.caseNumber = ''
                }
                person.assistancePrograms.push(prog)
            });
            persons.push(person)
        });
        let requiresDowngradeConfirmation = false;
        appData.studentList.map((student, p) => {
            persons.push(student);
            if (!skipConfirmation) {
                const prevStatus = (student.existingEligibilityStatus || '').toString().toLowerCase();
                const newIsFreeMeal = student.isFreeMeal;
                if ((prevStatus === 'free' && (newIsFreeMeal === false || newIsFreeMeal === null)) ||
                    (prevStatus === 'reduced' && newIsFreeMeal === null)) {
                    requiresDowngradeConfirmation = true;
                }
            }
        });
        // Only confirmation pop up for downgrades when the action is a final decision
        const isFinalAction = (action === 'APPROVED' || action === 'DENIED') || (action === 'PENDING-CONFIRM' && !enableConfirmingOfficial);
        if (requiresDowngradeConfirmation && !skipConfirmation && adverseActionProcedure && isFinalAction) {
            this.setState({
                conformationModalIsOpen: true,
                pendingUpdateType: 'savePendingDowngrade',
                pendingUpdateData: { action, appData }
            });
            return;
        }

        appData.childList.map((child, p) => {
            if (child.fname == '' || child.lname == '') {
                _addNotificationError('Please enter child details.', this.props.refNotify);
                isError = true;
            }
            persons.push(child);
        });
        appData.adultList.map((adult, p) => {
            if (adult.fname == '' || adult.lname == '') {
                _addNotificationError('Please enter adult details.', this.props.refNotify);
                isError = true;
            }
            persons.push(adult);
        });
        reqBody['declinedReasonList'] = appData.declinedReasonList;
        if ((appData.studentList.some((student) => {
            return student.isFreeMeal === null
        })) !== true) {
            reqBody.declinedReasonList = declinedReasonList.slice();
        }
        reqBody.householdAppInfo = persons;

        const hasEmptyCValue = (obj) => {
            return Array.isArray(obj.income) && obj.income.some(item => item.source === "" || item.frequency === "" || (parseFloat(item.amount === '' ? 0 : item.amount) <= 0));
        };

        // Check if any object has an empty "c" value
        const result = reqBody.householdAppInfo.some(hasEmptyCValue);

        if (result) {
            _addNotificationError('Please enter income details.', this.props.refNotify);
            isError = true;
        }

        /*  if(this.props.saveButtonLable !=="Save"){ */
        reqBody.statusUpdateDate = moment().format('MMDDYYYY');
        if (action === 'SAVE') {
            if ((appData.status || '').toString().toLowerCase() === 'in-complete') {
                reqBody.status = 'pending';
            }

            reqBody.incompleteReasonList = [];
            reqBody.editReason = this.state.editNote;
        } else if (action === 'incomplete') {
            reqBody.status = 'in-complete';
            reqBody.incompleteReasonList = stateAppData.incompleteReasonList.slice();
            reqBody.incompleteDueDate = this.getSystemDateTime(stateAppData.incompleteDueDate);
        }
        else if (action === 'CANCELAPP') {
            reqBody.status = 'cancelled';
            reqBody.cancelledNote = this.state.cancelReason;
        }
        else {

            if ((appData.status || '').toString().toLowerCase() == 'pending-confirm') {
                reqBody.status = 'pending-confirm';
                reqBody.determineOfficerUserId = appData.determineOfficerUserId;
                reqBody.determineDate = appData.determineDate;
                reqBody.incompleteReasonList = [];

            } else if (this.isApplicationIsDenied()) {
                reqBody.status = 'denied';
                reqBody.incompleteReasonList = [];
                if (!autoDecisionEligibility && (reqBody.determineOfficerUserId || '') == '') {
                    reqBody.determineOfficerUserId = loginUserInfo.userId;
                    reqBody.determineDate = new Date().toISOString();
                } else {
                    reqBody.confirmOfficerUserId = appData.confirmOfficerUserId;
                    reqBody.confirmDate = appData.confirmDate;

                }

            } else {
                reqBody.status = 'approved';
                if (!autoDecisionEligibility && !this.props.enableConfirmingOfficial) {
                    reqBody.determineOfficerUserId = loginUserInfo.userId;
                    reqBody.determineDate = new Date().toISOString();
                } else if (!autoDecisionEligibility && this.props.enableConfirmingOfficial) {
                    if (!confirmingOfficialUserIds.includes(loginUserInfo.userId)) {
                        _addNotificationError('You are not authorized to confirm the application status.', this.props.refNotify);
                        isError = true;
                        return;
                    }
                    reqBody.confirmOfficerUserId = loginUserInfo.userId;
                    reqBody.confirmDate = new Date().toISOString();
                } else {
                    if (!confirmingOfficialUserIds.includes(loginUserInfo.userId)) {
                        _addNotificationError('You are not authorized to confirm the application status.', this.props.refNotify);
                        isError = true;
                        return;
                    }
                    reqBody.confirmOfficerUserId = appData.confirmOfficerUserId;
                    reqBody.confirmDate = appData.confirmDate;

                }

                reqBody.incompleteReasonList = [];
            }

        }
        /* } */
        console.log("Request body:::: ", JSON.stringify(reqBody));
        let _serStatusCode = '';
        if (!isError) {
            postWithHeaders('/householdApplication?districtId=' + districtId + '&access_token=', JSON.stringify(reqBody), headers)
                .then((resp) => {
                    // if (!resp.ok) {
                    //     throw Error(resp.errorMessage);
                    // }
                    return resp.json();
                }).then(data => {
                    if (data.statusCode === 200) {
                        _addNotification(data.statusMessage, this.props.refNotify);
                        if (action === 'SAVE') {
                            this.setState({ isStateChanged: false, editNote: '', editNoteModalIsOpen: false }, () =>
                                this.props.onSubmitChanges())
                        } else if (action === 'incomplete') {
                            this.setState({ incompleteModalIsOpen: false }, () => {
                                this.props.onSubmitChanges();
                            });
                        } else if (action === 'CANCELAPP') {
                            this.setState({ cancelAppModalIsOpen: false, cancelledNote: '' }, () => {
                                this.props.onSubmitChanges();
                            });
                        } else {
                            this.props.onSubmitChanges();
                        }
                    } else if (data.statusCode === 400) {
                        _addNotificationError(data.statusMessage, this.props.refNotify);
                    } else {
                        _addNotificationError(data.statusMessage, this.props.refNotify);
                    }
                }).catch(
                    (error) => {
                        console.log('Details not saved', error);
                        _addNotificationError('Please try again!', this.props.refNotify);
                    }
                );
        }
    }
    renderEligibilityPrograms = () => {
    const { appData, eligibilityDeterminedByProgram } = this.props;

    // Use verification value when provided.
    // Otherwise keep existing application behavior.
    const selectedProgram = eligibilityDeterminedByProgram !== undefined && eligibilityDeterminedByProgram !== null ? eligibilityDeterminedByProgram : (appData.eligibilityDeterminedByProgam || '');
    let selectedId = 0;
      MealBenefitEligibilityPrograms.forEach((p) => {
        if ((p.value || []).includes(selectedProgram)) {
            selectedId = p.id;
        }
      });

        return (<div>
                <label>Decision Criteria:</label>
                <ul>
                    {MealBenefitEligibilityPrograms.map((program, i) => {
                        const programObj = program;
                        if ((program.value || []).includes(selectedProgram)) {
                            programObj.selected = true;
                        } else {
                            programObj.selected = false;
                        }
                        return (
                            <li key={i} style={{ margin: '2px 15px' }}>
                                <label>
                                    <i style={{ fontSize: '20px' }}
                                        className={ programObj.selected ? 'fa fa-check-circle color-2' : i < selectedId ? 'fa fa-times color-3' : 'fa fa-check-circle'
                                        }
                                    ></i>
                                </label>
                                <span style={{ marginLeft: '5px' }}>
                                    {programObj.text}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    isApplicationIsDenied = () => {
        const { appData } = this.state;
        let isAnyStudentRegular = appData.studentList.some(st => {
            return st.isFreeMeal === null
        });
        return isAnyStudentRegular;
    }
    isApplicationDeniedReasonFilled = () => {
        const { appData } = this.state;
        let isAnyStudentRegular = appData.studentList.some(st => {
            return st.isFreeMeal === null
        });
        if (isAnyStudentRegular) {
            const list = appData.declinedReasonList.filter(st => st.isApplicable == true)
            if (list.length > 0) {
                return list.every(r => {
                    return (r.description == null || r.description.length > 0)
                })
            } else {
                return false;
            }
        } else {
            return true;

        }
    }
findUpdatedMember = (list, member) => {
    return list.find(item => {
        // Match by memberId if available
        if (
            item.memberId &&
            member.memberId &&
            item.memberId === member.memberId
        ) {
            return true;
        }
        // Otherwise match by person details
        return (
            item.personType === member.personType &&
            item.filledTheApplication === member.filledTheApplication &&
            item.fname === member.fname &&
            item.lname === member.lname
        );
    });
};
  handleVerificationSave = () => {
    const appData = JSON.parse(JSON.stringify(this.state.appData));
    const assistancePrograms = (appData.assistancePrograms || []).map(program => ({
        ...program,
        caseNumber: program.isApplicable ? program.caseNumber : ''
    }));
    const householdAppInfo = appData.householdAppInfo.map(member => {
        let updated = { ...member };
        const student = this.findUpdatedMember(appData.studentList || [], member);
        if (student) updated = { ...updated, ...student };

        const child = this.findUpdatedMember(appData.childList || [], member);
        if (child) updated = { ...updated, ...child };

        const person = this.findUpdatedMember(appData.person || [], member);
        if (person) {
            updated = {
                ...updated,
                ...person,
                assistancePrograms: assistancePrograms.map(program => ({ ...program }))
            };
        }

        const adult = this.findUpdatedMember(appData.adultList || [], member);
        if (adult) updated = { ...updated, ...adult };

        return updated;
    });

    // Add newly created Child/Adult members
    householdAppInfo.push(
        ...(appData.childList || []).filter(
            c => !householdAppInfo.some(
                h =>
                    h.personType === "Child" &&
                    h.fname === c.fname &&
                    h.lname === c.lname
            )
        )
    );

    householdAppInfo.push(
        ...(appData.adultList || []).filter(
            a => !householdAppInfo.some(
                h =>
                    h.personType === "Adult" &&
                    h.fname === a.fname &&
                    h.lname === a.lname &&
                    !h.filledTheApplication
            )
        )
    );

    const requestBody = {
        applicationId: appData.applicationId,
        verifyId: appData.verifyId,
        status: appData.status,
        prmyParentEmail: appData.prmyParentEmail,
        incompleteDueDate: appData.incompleteDueDate ,
        mealSchoolId: appData.mealSchoolId,
        statusUpdateDate: appData.statusUpdateDate,
        schoolYear: appData.schoolYear,
        studentRecIds: appData.studentRecIds,
        householdAppInfo,
        childList: appData.childList,
        adultList: appData.adultList,
        studentList: appData.studentList,
        person: appData.person,
        declinedReasonList: appData.declinedReasonList,
        incompleteReasonList: appData.incompleteReasonList,
        determineOfficerUserId: appData.determineOfficerUserId,
        determineDate: appData.determineDate,
        confirmOfficerUserId: appData.confirmOfficerUserId,
        confirmDate: appData.confirmDate,
        editReason: appData.editReason,
        //assistancePrograms: appData.assistancePrograms,    
    };
    console.log(requestBody);
    this.props.onSubmitChanges(requestBody);
};
    render() {
        const { t, i18n, confirmingOfficialUserIds, loggedUser, autoDecisionEligibility } = this.props;
        const { appData } = this.state;
        const totObj = this.calculateTotal();
        return (
            <section style={{
                padding: '5px', border: '2px solid #aba8a847', borderRadius: '5px'
            }}>
                <div id={'app' + appData.applicationId}>
                    <div className="row">
                        <div className="col-md-12 text-center">
                            <h4 className="color-3"><Trans>Household Application for Free and Reduced Price School Meals</Trans></h4>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6 text-left">
                            <p><Trans>Application Id</Trans>:<strong> {("00000" + appData.applicationId).slice(-5)}</strong></p>
                        </div>
                        <div className="col-md-6 text-right">
                            <p><Trans>Date</Trans>:<strong> {moment(appData.date, 'MMDDYYYY').format('YYYY-MM-DD')}</strong></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">
                                <table className="table table-bordered" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            <th rowSpan="2"><Trans>Grade</Trans></th>
                                            <th colSpan="2"><Trans>Student?</Trans></th>
                                            {/*  <th rowSpan="2"><Trans>Foster Child</Trans></th> */}
                                            <th rowSpan="2" ><Trans>Homeless, Migrant, Runaway, Foster Child, Head Start</Trans></th>
                                            <th rowSpan="2" ></th>
                                        </tr>
                                        <tr>
                                            <th ><Trans>Yes</Trans></th>
                                            <th ><Trans>No</Trans></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            appData.studentList.map((student, k) => {
                                                return (
                                                    <tr key={k}>
                                                        <td style={{ padding: '2px' }}>
                                                            <input data-idx={k} className="form-control" value={student.fname} type="text" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.studentList[idx]['fname'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', width: '25%' }}>
                                                            <input data-idx={k} className="form-control" value={student.lname} type="text" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.studentList[idx]['lname'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', width: '9%' }}>
                                                            <input data-idx={k} className="form-control" type="text" value={student.grade} onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.studentList[idx]['grade'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" name={"isStudent-" + k + '-' + this.props.id} checked={student.personType === personType.student} readOnly /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" name={"isStudent-" + k + '-' + this.props.id} checked={student.personType !== personType.student} readOnly /></td>
                                                        {/*  <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '7%' }}>
                                                            <input className="chbox" data-idx={k} type="checkbox" checked={student.liveUnderFosterCare} onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.studentList[idx]['liveUnderFosterCare'] = e.target.checked ? true : false;
                                                                _appData.studentList[idx]['isFreeMeal'] = e.target.checked ? true : null;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td> */}
                                                        <td style={{ padding: '2px', verticalAlign: 'middle', width: '9%' }}>
                                                            <label className="checkbox-inline" style={{ display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Homeless"
                                                                    //checked={(student.homelessOrMigrantOrRunawayOptions||[]).includes('Homeless')}
                                                                    checked={student.mcKinneyVentoHomeless}
                                                                    onChange={(e) => {
                                                                        let _idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;
                                                                        _appData.studentList[_idx].mcKinneyVentoHomeless = e.target.checked;
                                                                        _appData.studentList[_idx].migrantEducationPrg = false;
                                                                        _appData.studentList[_idx].runaway = false
                                                                        _appData.studentList[_idx].headStart = false;
                                                                        _appData.studentList[_idx]['liveUnderFosterCare'] = false;
                                                                        _appData.studentList[_idx]['isFreeMeal'] = false;
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }} /><Trans>Homeless</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Migrant"
                                                                    //checked={(student.homelessOrMigrantOrRunawayOptions||[]).includes('Migrant')} 
                                                                    checked={student.migrantEducationPrg}
                                                                    onChange={(e) => {
                                                                        let _idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;

                                                                        _appData.studentList[_idx]['liveUnderFosterCare'] = false;
                                                                        _appData.studentList[_idx]['isFreeMeal'] = false;

                                                                        _appData.studentList[_idx].migrantEducationPrg = e.target.checked;
                                                                        _appData.studentList[_idx].mcKinneyVentoHomeless = false;
                                                                        _appData.studentList[_idx].runaway = false;
                                                                        _appData.studentList[_idx].headStart = false;
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }} /><Trans>Migrant</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Runaway"
                                                                    //checked={(student.homelessOrMigrantOrRunawayOptions||[]).includes('Runaway')} 
                                                                    checked={student.runaway}
                                                                    onChange={(e) => {
                                                                        let _idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;
                                                                        _appData.studentList[_idx]['liveUnderFosterCare'] = false;
                                                                        _appData.studentList[_idx]['isFreeMeal'] = false;

                                                                        _appData.studentList[_idx].runaway = e.target.checked
                                                                        _appData.studentList[_idx].migrantEducationPrg = false;
                                                                        _appData.studentList[_idx].mcKinneyVentoHomeless = false;
                                                                        _appData.studentList[_idx].headStart = false;
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }} /><Trans>Runaway</Trans>
                                                            </label>

                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value=""
                                                                    checked={student.liveUnderFosterCare}
                                                                    onChange={(e) => {
                                                                        let _idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;

                                                                        _appData.studentList[_idx]['liveUnderFosterCare'] = e.target.checked ? true : false;
                                                                        _appData.studentList[_idx]['isFreeMeal'] = e.target.checked ? true : null;

                                                                        _appData.studentList[_idx].runaway = false
                                                                        _appData.studentList[_idx].migrantEducationPrg = false;
                                                                        _appData.studentList[_idx].mcKinneyVentoHomeless = false;
                                                                        _appData.studentList[_idx].headStart = false;
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }} /><Trans>Foster Child</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="HeadStart"
                                                                    checked={student.headStart}
                                                                    onChange={(e) => {
                                                                        let _idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;

                                                                        _appData.studentList[_idx].headStart = e.target.checked;
                                                                        _appData.studentList[_idx]['isFreeMeal'] = e.target.checked ? true : null;

                                                                        _appData.studentList[_idx]['liveUnderFosterCare'] = false;
                                                                        _appData.studentList[_idx].runaway = false;
                                                                        _appData.studentList[_idx].migrantEducationPrg = false;
                                                                        _appData.studentList[_idx].mcKinneyVentoHomeless = false;
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }} /><Trans>Head Start</Trans>
                                                            </label>
                                                        </td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}></td>
                                                    </tr>
                                                )
                                            })
                                        }

                                        {
                                            appData.childList.map((student, k) => {
                                                return (
                                                    <tr>
                                                        <td style={{ padding: '2px' }}>
                                                            <input data-idx={k} className="form-control" name="fname" value={student.fname} type="text" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.childList[idx]['fname'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', width: '25%' }}>
                                                            <input data-idx={k} className="form-control" value={student.lname} type="text" onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.childList[idx]['lname'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', width: '9%' }}>
                                                            <input data-idx={k} className="form-control" type="text" value={student.grade} onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.childList[idx]['grade'] = e.target.value;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" name={"isStudent" + k + '-' + this.props.id}
                                                                checked={student.personType === personType.student} readOnly /></td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <input className="rdbox" data-idx={k} type="radio" name={"isStudent" + k + '-' + this.props.id} checked={student.personType !== personType.student} readOnly /></td>
                                                        {/*  <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '7%' }}>
                                                            <input className="chbox" data-idx={k} type="checkbox" name={'foster' + k} checked={student.liveUnderFosterCare === true} onChange={(e) => {
                                                                let idx = e.target.getAttribute('data-idx');
                                                                let _appData = this.state.appData;
                                                                _appData.childList[idx]['liveUnderFosterCare'] = e.target.checked ? true : false;
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }} /></td> */}
                                                        <td style={{ padding: '2px', verticalAlign: 'middle', width: '9%' }}>
                                                            <label className="checkbox-inline" style={{ display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Homeless"
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Homeless')}
                                                                    readOnly /><Trans>Homeless</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Migrant"
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Migrant')}
                                                                    readOnly /><Trans>Migrant</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="Runaway"
                                                                    checked={(student.homelessOrMigrantOrRunawayOptions || []).includes('Runaway')}
                                                                    readOnly /><Trans>Runaway</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value=""
                                                                    checked={student.liveUnderFosterCare}
                                                                    readOnly /><Trans>Foster Child</Trans>
                                                            </label>
                                                            <label className="checkbox-inline" style={{ marginLeft: '0px', display: 'block' }}>
                                                                <input type="checkbox" data-idx={k} value="HeadStart"
                                                                    checked={student.headStart}
                                                                    readOnly /><Trans>Head Start</Trans>
                                                            </label>
                                                            {/* <input className="chbox" data-idx={k} type="checkbox" name={'homeless'+k}
                                            checked={student.runaway===true} readOnly /> */}
                                                        </td>
                                                        <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                            <button data-idx={k} className="btn-social btn-linkedin-link pull-right" onClick={(e) => {
                                                                let idx = e.target.parentNode.getAttribute('data-idx')
                                                                let _appData = this.state.appData;
                                                                _appData.childList.splice(idx, 1);
                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                            }}><i className="fa fa-trash"></i></button>

                                                        </td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan="8"><button className="btn-social btn-linkedin-link pull-right" onClick={() => {
                                                let newChild = JSON.parse(JSON.stringify(personModal));
                                                newChild.personType = personType.child;
                                                newChild.runaway = false;
                                                let _appData = this.state.appData;
                                                _appData.childList.push(newChild);
                                                this.setState({ appData: _appData, isStateChanged: true });
                                            }}><Trans>Add Child</Trans></button></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Add Or Edit Adult</label>
                        </div>
                        <div className="col-md-12">
                            <table className="table table-bordered" cellPadding="0" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>EMail</th>
                                        <th width="100px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        appData.person.map((ad, i) => {
                                            return <tr>
                                                <td className="fname" >
                                                    <input type="text" data-idx={i} className="form-control" value={ad.fname} onChange={(e) => {
                                                        let idx = i;
                                                        let _appData = this.state.appData;
                                                        let _person = _appData.person;
                                                        _person[idx].fname = e.target.value
                                                        _appData.person = [..._person];
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }} /></td>
                                                <td className="lname">
                                                    <input type="text" data-idx={i} className="form-control" value={ad.lname} onChange={(e) => {
                                                        let idx = i;
                                                        let _appData = { ...this.state.appData };
                                                        let _person = [...(_appData.person || [])];
                                                        _person[idx] = { ..._person[idx], lname: e.target.value };
                                                        _appData.person = _person;
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }} />
                                                </td>
                                                {/* email is editable only for primary parent contact if empty also allows */}
                                                {/* updated email was displayed and editable if empty also allowing */}
                                                <td className="email">
                                                    <input type="text" data-idx={i} className="form-control"
                                                       value={ad.email !== undefined ? ad.email : ''}
                                                        onChange={(e) => {
                                                            let idx = i;
                                                            let _appData = { ...this.state.appData };
                                                            let _person = [...(_appData.person || [])];
                                                            let person = { ...(_person[idx] || {}) };
                                                            person.email = e.target.value;
                                                            person.contact = { ...(person.contact || {}), email: e.target.value };
                                                            person.isPrimaryParent = true;
                                                            person.personType = personType.adult;
                                                            _person[idx] = person;
                                                            _appData.person = _person;
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                        }}
                                                        />
                                                </td>
                                                <td></td>
                                            </tr>
                                        })
                                    }
                                    {
                                        appData.adultList.map((ad1, j) => {
                                            return <tr>
                                                <td className="fname" >
                                                    <input type="text" data-idx={j} className="form-control" value={ad1.fname} onChange={(e) => {
                                                        let idx = j;
                                                        let _appData = this.state.appData;
                                                        let _adultList = _appData.adultList;
                                                        _adultList[idx].fname = e.target.value
                                                        _appData.adultList = [..._adultList];
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }} /></td>
                                                <td className="lname">
                                                    <input type="text" data-idx={j} className="form-control" value={ad1.lname} onChange={(e) => {
                                                        let idx = j;
                                                        let _appData = this.state.appData;
                                                        let _adultList = _appData.adultList;
                                                        _adultList[idx].lname = e.target.value
                                                        _appData.adultList = [..._adultList];
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }} />
                                                </td>
                                                <td></td>
                                                <td style={{ padding: '2px', textAlign: 'center', verticalAlign: 'middle', width: '5%' }}>
                                                    <button data-idx={j} className="btn-social btn-linkedin-link pull-right" onClick={(e) => {
                                                        let idx = j
                                                        let _appData = this.state.appData;
                                                        _appData.adultList.splice(idx, 1);
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }}><i className="fa fa-trash"></i></button>

                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={3}>
                                            <button className="btn-social btn-linkedin-link pull-right" onClick={() => {
                                                let newChild = JSON.parse(JSON.stringify(personModal));
                                                newChild.personType = personType.adult;
                                                let _appData = this.state.appData;
                                                _appData.adultList.push(newChild);
                                                this.setState({ appData: _appData, isStateChanged: true });
                                            }}><Trans>Add Adult</Trans></button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label><Trans>Do any Household Members (including you) currently participate in one or more of the following assistance programs</Trans>: SNAP, TANF, or FDPIR? </label>
                        </div>
                        <div className="col-md-12">
                            <ul className="list-unstyled para-list">
                                {
                                    appData.assistancePrograms.map((program, p) => {
                                        return <li key={p}>
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <i className="fa fa-hand-o-right" aria-hidden="true"></i>
                                                    <input className="chbox" type="checkbox" data-idx={p} checked={program.isApplicable === true} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx')
                                                        let _appData = this.state.appData;
                                                        _appData.assistancePrograms[idx]['isApplicable'] = e.target.checked ? true : false;
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                    }} /> <Trans>{program.name}</Trans>
                                                </div>{
                                                    program.isApplicable === true ?
                                                        <div className="col-md-3">
                                                            <input type="text" data-idx={p} className="form-control" placeholder={t('Case Number')}
                                                                value={program.caseNumber} onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx')
                                                                    let _appData = this.state.appData;
                                                                    _appData.assistancePrograms[idx]['caseNumber'] = e.target.value;
                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                }} />
                                                        </div> : null
                                                }

                                            </div>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <label><Trans>Report Income for ALL Household Members</Trans> </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="table-responsive">

                                <table className="table table-bordered table-income" cellPadding="0" cellSpacing="0">
                                    <thead>
                                        <tr>
                                            <th rowSpan="2"><Trans>First Name</Trans></th>
                                            <th rowSpan="2"><Trans>Last Name</Trans></th>
                                            <th colSpan="4"><Trans>Income ($)</Trans></th>
                                        </tr>
                                        <tr>
                                            <th><Trans>Source</Trans></th>
                                            <th><Trans>Frequency</Trans></th>
                                            <th><Trans>Amount</Trans></th>
                                            {/* <th>Income ($) (Annual)</th> */}
                                            <th width="50px"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            appData.studentList.map((student, k) => {
                                                if (student.liveUnderFosterCare === false)
                                                    return (
                                                        <Fragment>
                                                            <tr>
                                                                <td className="fname " rowSpan={student.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                    <label>{student.fname}</label></td>
                                                                <td className="lname" rowSpan={student.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                    <label>{student.lname}</label><br />
                                                                    <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                        let midx = e.target.getAttribute('data-midx');
                                                                        let _appData = this.state.appData;
                                                                        _appData.studentList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }}><Trans>Add income source</Trans></button>
                                                                </td>
                                                                <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                            </tr>
                                                            {
                                                                student.income.map((inc, i) => {
                                                                    return (
                                                                        <tr>
                                                                            <td className="incSource">
                                                                                <select className="form-control" data-midx={k} data-sidx={i} name='source'
                                                                                    value={inc.source} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.studentList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }}>
                                                                                    <option></option>
                                                                                    {
                                                                                        (() => {
                                                                                            const selectedSources = student.income
                                                                                                .map(i => i.source)
                                                                                                .filter(src => src !== '');

                                                                                            const availableSources = childIncomeTypeList.filter((incType) => {
                                                                                                return !selectedSources.includes(incType) || incType === inc.source;
                                                                                            });

                                                                                            return availableSources.map((incType, t) => (
                                                                                                <option key={t} value={incType}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            ));
                                                                                        })()
                                                                                    }
                                                                                </select>
                                                                            </td>
                                                                            <td className="freeqCol">
                                                                                <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                    value={inc.frequency} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.studentList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }}>
                                                                                    <option value={0}></option>
                                                                                    {
                                                                                        IncomFreqency.map((freq, f) => {
                                                                                            return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                            </td>
                                                                            <td className="incomeCol">
                                                                                <input type="text" className="form-control" data-midx={k}
                                                                                    data-sidx={i} name='amount' value={inc.amount} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.studentList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }} />
                                                                            </td>
                                                                            {/*  <td className="incTot">
                                                                {yearlyIncome(inc.frequency,inc.amount) }
                                                                </td> */}
                                                                            <td className="text-center">
                                                                                <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                    let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                    let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    if (_appData.studentList[midx].income.length > 0) {
                                                                                        _appData.studentList[midx].income.splice(sidx, 1)
                                                                                    }
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                    <i className="fa fa-trash"></i></button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </Fragment>
                                                    )
                                            })
                                        }
                                        {
                                            appData.childList.map((child, k) => {
                                                if (child.liveUnderFosterCare === false)
                                                    return (
                                                        <Fragment>
                                                            <tr>
                                                                <td className="fname" rowSpan={child.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                    <label>{child.fname}</label>
                                                                </td>
                                                                <td className="fname" rowSpan={child.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                    <label>{child.lname}</label><br />
                                                                    <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                        let midx = e.target.getAttribute('data-midx');
                                                                        let _appData = this.state.appData;
                                                                        _appData.childList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                    }}><Trans>Add income source</Trans></button></td>
                                                                <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                            </tr>
                                                            {
                                                                child.income.map((inc, i) => {
                                                                    return (
                                                                        <tr>
                                                                            <td className="incSource">
                                                                                <select className="form-control" data-midx={k} data-sidx={i} name='source'
                                                                                    value={inc.source} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }}>
                                                                                    <option value={0}></option>
                                                                                     {
                                                                                        (() => {
                                                                                            const selectedSources = child.income
                                                                                                .map(i => i.source)
                                                                                                .filter(src => src !== '');

                                                                                            const availableSources = childIncomeTypeList.filter((incType) => {
                                                                                                return !selectedSources.includes(incType) || incType === inc.source;
                                                                                            });

                                                                                            return availableSources.map((incType, t) => (
                                                                                                <option key={t} value={incType}>
                                                                                                    <Trans>{incType}</Trans>
                                                                                                </option>
                                                                                            ));
                                                                                        })()
                                                                                    }
                                                                                </select>
                                                                            </td>
                                                                            <td className="freeqCol">
                                                                                <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                    value={inc.frequency} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }}>
                                                                                    <option></option>
                                                                                    {
                                                                                        IncomFreqency.map((freq, f) => {
                                                                                            return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                        })
                                                                                    }
                                                                                </select>
                                                                            </td>
                                                                            <td className="incomeCol">
                                                                                <input type="text" className="form-control" data-midx={k} data-sidx={i} name='amount'
                                                                                    value={inc.amount} onChange={(e) => {
                                                                                        let midx = e.target.getAttribute('data-midx');
                                                                                        let sidx = e.target.getAttribute('data-sidx');
                                                                                        let _appData = this.state.appData;
                                                                                        _appData.childList[midx].income[sidx][e.target.name] = e.target.value
                                                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                                                    }} /></td>
                                                                            {/*  <td className="incTot">
                                                                {yearlyIncome(inc.frequency,inc.amount) }
                                                                </td> */}
                                                                            <td className="text-center">
                                                                                <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                    let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                    let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.childList[midx].income.splice(sidx, 1)
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                    <i className="fa fa-trash"></i></button>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }

                                                        </Fragment>
                                                    )

                                            })
                                        }
                                        {
                                            appData.person.map((adult, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={adult.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                <label>{adult.fname}</label></td>
                                                            <td className="lname" rowSpan={adult.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                <label>{adult.lname}</label> <br />
                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _appData = this.state.appData;
                                                                    _appData.person[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                }}><Trans>Add income source</Trans></button></td>
                                                            <td colSpan="4" style={{ padding: '0px', border: '0px' }}></td>
                                                        </tr>
                                                        {
                                                            adult.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source' value={inc.source}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.person[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                <option></option>
                                                                                {
                                                                                    (() => {
                                                                                        const selectedSources = adult.income
                                                                                            .map(i => i.source)
                                                                                            .filter(src => src !== '');

                                                                                        const availableSources = childIncomeTypeList.filter((incType) => {
                                                                                            return !selectedSources.includes(incType) || incType === inc.source;
                                                                                        });

                                                                                        return availableSources.map((incType, t) => (
                                                                                            <option key={t} value={incType}>
                                                                                                <Trans>{incType}</Trans>
                                                                                            </option>
                                                                                        ));
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency' value={inc.frequency}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.person[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol"><input type="text" data-midx={k} data-sidx={i} name='amount'
                                                                            className="form-control" value={inc.amount}
                                                                            onChange={(e) => {
                                                                                let midx = e.target.getAttribute('data-midx');
                                                                                let sidx = e.target.getAttribute('data-sidx');
                                                                                let _appData = this.state.appData;
                                                                                _appData.person[midx].income[sidx][e.target.name] = e.target.value
                                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                                            }}

                                                                        /></td>
                                                                        {/*  <td className="incTot">
                                                                {yearlyIncome(inc.frequency,inc.amount) }
                                                                </td> */}
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _appData = this.state.appData;
                                                                                _appData.person[midx].income.splice(sidx, 1)
                                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </Fragment>
                                                )

                                            })
                                        }
                                        {
                                            appData.adultList.map((adult, k) => {
                                                return (
                                                    <Fragment>
                                                        <tr>
                                                            <td className="fname" rowSpan={adult.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                <label>{adult.fname}</label></td>
                                                            <td className="lname" rowSpan={adult.income.length + 1} style={{ paddingLeft: '5px', paddingTop: '5px' }}>
                                                                <label>{adult.lname}</label>< br />

                                                                <button type="button" data-midx={k} className="btn-facebook-link text-right" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                    let midx = e.target.getAttribute('data-midx');
                                                                    let _appData = this.state.appData;
                                                                    _appData.adultList[midx].income.push(JSON.parse(JSON.stringify(incomeModal)))
                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                }}><Trans>Add income source</Trans></button></td>
                                                            <td colSpan="4" className="text-right" style={{ padding: '0px', border: '0px' }}>
                                                            </td>

                                                        </tr>
                                                        {
                                                            adult.income.map((inc, i) => {
                                                                return (
                                                                    <tr>
                                                                        <td className="incSource">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='source' value={inc.source}
                                                                                onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                <option></option>
                                                                                {
                                                                                    (() => {
                                                                                        const selectedSources = adult.income
                                                                                            .map(i => i.source)
                                                                                            .filter(src => src !== '');

                                                                                        const availableSources = childIncomeTypeList.filter((incType) => {
                                                                                            return !selectedSources.includes(incType) || incType === inc.source;
                                                                                        });

                                                                                        return availableSources.map((incType, t) => (
                                                                                            <option key={t} value={incType}>
                                                                                                <Trans>{incType}</Trans>
                                                                                            </option>
                                                                                        ));
                                                                                    })()
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="freeqCol">
                                                                            <select className="form-control" data-midx={k} data-sidx={i} name='frequency'
                                                                                value={inc.frequency} onChange={(e) => {
                                                                                    let midx = e.target.getAttribute('data-midx');
                                                                                    let sidx = e.target.getAttribute('data-sidx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                    this.setState({ appData: _appData, isStateChanged: true });
                                                                                }}>
                                                                                <option value={0}></option>
                                                                                {
                                                                                    IncomFreqency.map((freq, f) => {
                                                                                        return <option key={f} value={freq.value}><Trans>{freq.text}</Trans></option>
                                                                                    })
                                                                                }
                                                                            </select>
                                                                        </td>
                                                                        <td className="incomeCol">
                                                                            <input type="text" className="form-control" data-midx={k} data-sidx={i} name='amount' value={inc.amount} onChange={(e) => {
                                                                                let midx = e.target.getAttribute('data-midx');
                                                                                let sidx = e.target.getAttribute('data-sidx');
                                                                                let _appData = this.state.appData;
                                                                                _appData.adultList[midx].income[sidx][e.target.name] = e.target.value
                                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                                            }} /></td>
                                                                        {/*  <td className="incTot">
                                                                {yearlyIncome(inc.frequency,inc.amount) }
                                                                </td> */}
                                                                        <td className="text-center">
                                                                            <button data-midx={k} data-sidx={i} className="btn-facebook-link" style={{ fontSize: '12px' }} onClick={(e) => {
                                                                                let midx = e.target.parentNode.getAttribute('data-midx');
                                                                                let sidx = e.target.parentNode.getAttribute('data-sidx');
                                                                                let _appData = this.state.appData;
                                                                                _appData.adultList[midx].income.splice(sidx, 1)
                                                                                this.setState({ appData: _appData, isStateChanged: true });
                                                                            }}>
                                                                                <i className="fa fa-trash"></i></button>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                        }

                                                    </Fragment>
                                                )

                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12" style={{ paddingBottom: '20px' }}>
                            <label><Trans>Contact information</Trans></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label><Trans>Email</Trans></label>
                            <input type="text" name="email" className="form-control"
                                value={(appData.person[0].contact || {}).email || ''} onChange={(e) => {
                                    let _appData = { ...this.state.appData };
                                    _appData.person = [...(_appData.person || [])];
                                    _appData.person[0] = { ...(_appData.person[0] || {}), contact: { ...((_appData.person[0] || {}).contact || {}), [e.target.name]: e.target.value } };
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>Phone</Trans></label>
                            <input type="text" name="phone" className="form-control"
                                value={appData.person[0].contact.phone} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>Address 1</Trans></label>
                            <input type="text" name="street1" className="form-control"
                                value={appData.person[0].contact.street1} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label><Trans>Address 2</Trans></label>
                            <input type="text" name="street2" className="form-control"
                                value={appData.person[0].contact.street2} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>City</Trans></label>
                            <input type="text" name="city" className="form-control"
                                value={appData.person[0].contact.city} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                        <div className="col-md-4">
                            <label><Trans>State</Trans></label>
                            <select name="state" className="form-control"
                                value={appData.person[0].contact.state} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }}>
                                <option value=""></option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <label><Trans>Zip</Trans></label>
                            <input type="text" name="zip" className="form-control"
                                value={appData.person[0].contact.zip} onChange={(e) => {
                                    let _appData = this.state.appData;
                                    _appData.person[0]['contact'][e.target.name] = e.target.value;
                                    this.setState({ appData: _appData, isStateChanged: true });
                                }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12" >
                            <label><Trans>Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member</Trans></label>
                            <div className="row">
                                <div className="col-md-4">
                                    <input type="text" name="ssn" className="form-control text-right" minLength="4" maxLength="4"
                                        placeHolder={'XXXX'} value={appData.person[0].ssn} onKeyPress={numberOnly} readOnly={appData.person[0].noSSN === true} onChange={(e) => {
                                            let _appData = this.state.appData;
                                            _appData.person[0][e.target.name] = e.target.value;
                                            this.setState({ appData: _appData, isStateChanged: true });
                                        }} />
                                </div>
                                <div className="col-md-4">
                                    <div style={{ marginTop: '7px' }}>
                                        <input type="checkbox" name="noSSN"
                                            checked={appData.person[0].noSSN === true}
                                            onChange={(e) => {
                                                let _appData = this.state.appData;
                                                _appData.person[0][e.target.name] = e.target.checked ? true : false;
                                                this.setState({ appData: _appData, isStateChanged: true });
                                            }} /> <label><Trans>No SSN</Trans></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            <label><Trans>Children's Racial and Ethnic Identities</Trans></label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12" >
                            {
                                appData.studentList.map((item, k) => {
                                    return (
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5>{item.lname + ' ' + item.fname}</h5>
                                                <div className="col-md-4">
                                                    <label><Trans>{'Ethnicity'}</Trans></label><br />
                                                    <input className="rdbox" type="radio" name={"ethnicity" + k + '-' + this.props.id} data-idx={k} checked={item.ethenticity === 'Hispanic or Latino'} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx');
                                                        let _appData = this.state.appData;
                                                        _appData.studentList[idx]['ethenticity'] = e.target.checked ? 'Hispanic or Latino' : '';
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                        // this.props.onEthnicChange(idx,'ethenticity',e.target.checked?true:false)

                                                    }} /> <label><Trans>Hispanic or Latino</Trans></label><br />
                                                    <input className="rdbox" type="radio" name={"ethnicity" + k + '-' + this.props.id} data-idx={k} checked={item.ethenticity === 'Not Hispanic or Latino'} onChange={(e) => {
                                                        let idx = e.target.getAttribute('data-idx')
                                                        let _appData = this.state.appData;
                                                        _appData.studentList[idx]['ethenticity'] = e.target.checked ? 'Not Hispanic or Latino' : '';
                                                        this.setState({ appData: _appData, isStateChanged: true });
                                                        // this.props.onEthnicChange(idx,'ethenticity',e.target.checked?false:true)
                                                    }} /> <label><Trans>Not Hispanic or Latino</Trans></label>
                                                </div>
                                                <div className="col-md-6">
                                                    <label><Trans>{'Race'}</Trans></label><br />
                                                    <input className="chbox" type="checkbox" name={"AIAN" + k} data-idx={k}
                                                        checked={(item.race).includes('American Indian or Alaskan Native')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'American Indian or Alaskan Native'
                                                            let _appData = this.state.appData;
                                                            let raceArray = []
                                                            if (_appData.studentList[idx].race.length > 0) {
                                                                raceArray = _appData.studentList[idx].race;
                                                            }
                                                            if (_appData.studentList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _appData.studentList[idx].race = raceArray
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                            // this.props.onRacialChange(idx,'American Indian or Alaskan Native',e.target.checked?true:false)
                                                        }} /> <label><Trans>American Indian or Alaskan Native</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"Asian" + k} name={"Asian" + k} data-idx={k}
                                                        checked={item.race.includes('Asian')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx');
                                                            let value = 'Asian'
                                                            let _appData = this.state.appData;
                                                            let raceArray = []
                                                            if (_appData.studentList[idx].race.length > 0) {
                                                                raceArray = _appData.studentList[idx].race;
                                                            }
                                                            if (_appData.studentList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _appData.studentList[idx].race = raceArray
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                            //this.props.onRacialChange(idx,'Asian',e.target.checked?true:false)
                                                        }} /> <label><Trans>Asian</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"BAA" + k} name={"BAA" + k} data-idx={k}
                                                        checked={item.race.includes('Black or African American')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'Black or African American'
                                                            let _appData = this.state.appData;
                                                            let raceArray = []
                                                            if (_appData.studentList[idx].race.length > 0) {
                                                                raceArray = _appData.studentList[idx].race;
                                                            }
                                                            if (_appData.studentList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _appData.studentList[idx].race = raceArray
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                            //this.props.onRacialChange(idx,'Black or African American',e.target.checked?true:false)
                                                        }} /> <label><Trans>Black or African American</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"NHOPI" + k} name={"NHOPI" + k} data-idx={k}
                                                        checked={item.race.includes('Native Hawaiian or Other Pacific Islander')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'Native Hawaiian or Other Pacific Islander'
                                                            let _appData = this.state.appData;
                                                            let raceArray = []
                                                            if (_appData.studentList[idx].race.length > 0) {
                                                                raceArray = _appData.studentList[idx].race;
                                                            }
                                                            if (_appData.studentList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _appData.studentList[idx].race = raceArray
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                            // this.props.onRacialChange(idx,'Native Hawaiian or Other Pacific Islander',e.target.checked?true:false)
                                                        }} /> <label><Trans>Native Hawaiian or Other Pacific Islander</Trans></label><br />
                                                    <input className="chbox" type="checkbox" id={"White" + k} name={"White" + k} data-idx={k}
                                                        checked={item.race.includes('White')}
                                                        onChange={(e) => {
                                                            let idx = e.target.getAttribute('data-idx')
                                                            let value = 'White'
                                                            let _appData = this.state.appData;
                                                            let raceArray = []
                                                            if (_appData.studentList[idx].race.length > 0) {
                                                                raceArray = _appData.studentList[idx].race;
                                                            }
                                                            if (_appData.studentList[idx].race.includes(value)) {
                                                                var _idx = raceArray.indexOf(value);
                                                                if (_idx > -1) {
                                                                    raceArray.splice(_idx, 1);
                                                                }
                                                            }
                                                            if (e.target.checked) {
                                                                raceArray.push(value);
                                                            }
                                                            _appData.studentList[idx].race = raceArray
                                                            this.setState({ appData: _appData, isStateChanged: true });
                                                            // this.props.onRacialChange(idx,'White',e.target.checked?true:false)
                                                        }} /> <label><Trans>White</Trans></label>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                )
                            }
                        </div>
                    </div>
                    <div className="row" style={{ marginBottom: '20px' }}>
                        <div className="col-md-3">
                            <label><Trans>Total Income</Trans> <span style={{ fontSize: '11px', textTransform: 'lowercase' }}>(per {totObj.frequency})</span></label>
                            <input type="text" value={totObj.totalAmount} className="form-control" />
                        </div>
                        <div className="col-md-3">
                            <label><Trans>Household size</Trans></label>
                            <input type="text" value={totObj.size} className="form-control" />
                        </div>
                    </div>
                    {
                        this.props.isAdmin ?
                            <div className="row">
                                <div className="col-md-8">
                                    <table className="table table-bordered table-status">
                                        <thead>
                                            <tr>
                                                <th rowSpan='2'><Trans>Student</Trans></th>
                                                <th colSpan='3' ><Trans>Eligibility</Trans></th>
                                            </tr>
                                            <tr>
                                                <th><Trans>Free</Trans></th>
                                                <th><Trans>Reduced</Trans></th>
                                                <th><Trans>Regular</Trans></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                appData.studentList.map((student, k) => {
                                                    return (
                                                        <tr>
                                                            <td>{student.fname + ' ' + student.lname}</td>
                                                            <td className="eligibility text-center">
                                                                <input type="radio" className="rdbox" data-idx={k} name={"isFreeMeal" + k + '-' + this.props.id}
                                                                    checked={student.isFreeMeal === true}
                                                                    onChange={(e) => {
                                                                        let idx = e.target.getAttribute('data-idx');
                                                                        let _appData = this.state.appData;
                                                                        _appData.studentList[idx]['isFreeMeal'] = e.target.checked ? true : null;
                                                                        this.setState({
                                                                            appData: _appData
                                                                            //,isStateChanged:true
                                                                        });
                                                                    }} />
                                                            </td>
                                                            <td className="eligibility text-center"><input className="rdbox" type="radio" data-idx={k} name={"isFreeMeal" + k + '-' + this.props.id}
                                                                checked={student.isFreeMeal === false}
                                                                onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx');
                                                                    let _appData = this.state.appData;
                                                                    _appData.studentList[idx]['isFreeMeal'] = e.target.checked ? false : null;
                                                                    this.setState({
                                                                        appData: _appData
                                                                        //,isStateChanged:true
                                                                    });

                                                                }} /></td>
                                                            <td className="eligibility text-center"><input className="rdbox" type="radio" data-idx={k} name={"isFreeMeal" + k + '-' + this.props.id}
                                                                checked={student.isFreeMeal === null}
                                                                onChange={(e) => {
                                                                    let idx = e.target.getAttribute('data-idx');
                                                                    let _appData = this.state.appData;
                                                                    if (e.target.checked) {
                                                                        _appData.studentList[idx]['isFreeMeal'] = null
                                                                    }
                                                                    this.setState({
                                                                        appData: _appData
                                                                        //,isStateChanged:true
                                                                    });
                                                                }} /></td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className='col-md-4'>
                                    {
                                        this.renderEligibilityPrograms()
                                    }
                                </div>
                                {
                                    (appData.studentList.some((student) => {
                                        return student.isFreeMeal === null
                                    })) === true ?
                                        <div className="col-md-8">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: '30%' }}><Trans>Name</Trans></th>
                                                        <th><Trans>Reason for decline</Trans></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <ul>
                                                                {appData.studentList.map((student) => {
                                                                    if (student.isFreeMeal === null) {
                                                                        return <li>{student.fname + ' ' + student.lname}</li>
                                                                    }
                                                                })}
                                                            </ul>
                                                        </td>
                                                        <td>
                                                            <ul>
                                                                {
                                                                    appData.declinedReasonList.map((reason, r) => {
                                                                        return (
                                                                            <li><input className="chbox" type="checkbox" data-idx={r}
                                                                                checked={reason.isApplicable}
                                                                                onChange={(e) => {
                                                                                    let idx = e.target.getAttribute('data-idx');
                                                                                    let _appData = this.state.appData;
                                                                                    _appData.declinedReasonList[idx].isApplicable = e.target.checked;
                                                                                    this.setState({ appData: _appData });
                                                                                }} /> <label>{reason.name}</label>
                                                                                {
                                                                                    reason.isApplicable === true && reason.description !== undefined ?
                                                                                        <textarea rows="3" cols="50" data-idx={r} className='form-control'
                                                                                            value={reason.description} onChange={(e) => {
                                                                                                let idx = e.target.getAttribute('data-idx');
                                                                                                let _appData = this.state.appData;
                                                                                                _appData.declinedReasonList[idx].description = e.target.value;
                                                                                                this.setState({ appData: _appData });
                                                                                            }}>
                                                                                        </textarea> : null
                                                                                }
                                                                            </li>
                                                                        )

                                                                    })
                                                                }
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div> : null
                                }
                            </div> :
                            null
                    }
                    <div className='row'>
                        <div className='col-md-2'>
                            <label><Trans>Determining Official</Trans></label>
                            <div style={{ border: 'solid 1px #c0c0c0', padding: '5px', borderRadius: '4px', minHeight: '40px', background: '#f6f6f6', fontWeight: 'bold' }}>
                                {appData.determineOfficialFirstName || ''} {appData.determineOfficialLastName || ''}
                            </div>
                        </div>
                        <div className='col-md-2'>
                            <label><Trans>Determined On</Trans></label>
                            <div style={{ border: 'solid 1px #c0c0c0', padding: '5px', borderRadius: '4px', minHeight: '40px', background: '#f6f6f6', fontWeight: 'bold' }}>
                                {appData.determineDate ? new Date(appData.determineDate).toLocaleDateString() : ''}
                            </div>
                        </div>
                        {
                            this.props.enableConfirmingOfficial && <Fragment>
                                <div className='col-md-2'>
                                    <label><Trans>Confirming Official</Trans></label>
                                    <div style={{ border: 'solid 1px #c0c0c0', padding: '5px', borderRadius: '4px', minHeight: '40px', background: '#f6f6f6', fontWeight: 'bold' }}>
                                        {appData.confirmOfficialFirstName || ''} {appData.confirmOfficialLastName || ''}
                                    </div>
                                </div>
                                <div className='col-md-2'>
                                    <label><Trans>Confirmed On</Trans></label>
                                    <div style={{ border: 'solid 1px #c0c0c0', padding: '5px', borderRadius: '4px', minHeight: '40px', background: '#f6f6f6', fontWeight: 'bold' }}>
                                        {appData.confirmDate ? new Date(appData.confirmDate).toLocaleDateString() : ''}
                                    </div>
                                </div>
                            </Fragment>
                        }
                    </div>



                    <div className="row" style={{ marginTop: '20px', marginBottom: '20px' }}>
                        {
                            appData.status == 'cancelled' || appData.status == 'approved' || appData.status == 'in-complete' || appData.status == 'denied' || !this.props.isAdmin ?
                                <div className="col-md-12">
                                    <p className={appData.status == 'approved' ? 'alert alert-success' : appData.status == 'cancelled' ? 'alert alert-danger' : appData.status == 'in-complete' ? 'alert alert-default' : 'alert alert-info'}>
                                        <label><Trans>Application Status</Trans>:</label> <span>{appData.status}</span> <br />
                                        {
                                            appData.status == 'cancelled' ?
                                                <Fragment><label><Trans>Reason</Trans>:</label> <span> {appData.cancelledNote} </span></Fragment> :
                                                appData.status == 'in-complete' ?
                                                    <Fragment>
                                                        <label><Trans>Reason</Trans>:</label><br />
                                                        <ul style={{ textAlign: 'left', marginLeft: '10px' }}>
                                                            {(appData.incompleteReasonList || []).map((item, i) => {
                                                                if (item.isApplicable) {
                                                                    return <li style={{ marginBottom: '5px' }}>{item.name === 'Other:' ? item.description : item.name
                                                                    }</li>
                                                                }
                                                            })}
                                                        </ul>
                                                    </Fragment>
                                                    : null
                                        }
                                    </p>
                                </div>
                                : null
                        }
                        <div className='col-md-12 text-center'>
                            {
                                this.state.isStateChanged && appData.status !== 'approved' && appData.status !== 'denied' && appData.status !== 'cancelled' ?
                                    <button className="btn btn-xs btn-success" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {
                                        this.setState({ editNoteModalIsOpen: true })
                                    }}><Trans>Save</Trans></button> : null
                            }
                            {
                                this.props.isAdmin ?
                                    <Fragment>
                                        {
                                            !this.state.isStateChanged && appData.status !== 'approved' && appData.status !== 'denied' && appData.status !== 'cancelled' ? this.props.saveButtonLable ? <Fragment>
                                                <button className="btn btn-xs btn-success" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {
                                                    //this.onSubmitApp(e,'APPROVED');
                                                    if (this.props.saveButtonLable) {
                                                        this.onSubmitApp(e, 'APPROVED', this.state.appData);
                                                    } else {
                                                        if (this.isApplicationIsDenied()) {
                                                            if (this.isApplicationDeniedReasonFilled()) {
                                                                // this.onSubmitApp(e, 'APPROVED');
                                                                this.setState({ modalIsOpen: true });
                                                            } else {
                                                                _addNotificationError("Please provide reason for decline application?", this.props.refNotify);
                                                            }
                                                        } else {
                                                            this.setState({ modalIsOpen: true });
                                                        }
                                                    }

                                                }}>{this.props.saveButtonLable}</button>

                                            </Fragment> : <Fragment>
                                                {
                                                    (!autoDecisionEligibility && (appData.status == 'pending' || appData.status == 'in-complete')) && <button className="btn btn-xs btn-success" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {

                                                        if (this.isApplicationIsDenied()) {
                                                            if (this.isApplicationDeniedReasonFilled()) {
                                                                // this.onSubmitApp(e, 'APPROVED');
                                                                this.setState({ modalIsOpen: true });
                                                            } else {
                                                                _addNotificationError("Please provide reason for decline application?", this.props.refNotify);
                                                            }
                                                        } else {
                                                            this.setState({ modalIsOpen: true });
                                                        }

                                                    }}>Determine</button>
                                                }{
                                                    (appData.status == 'pending-confirm') && this.props.enableConfirmingOfficial && <button className="btn btn-xs btn-success" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {
                                                        if (this.isApplicationIsDenied()) {
                                                            if (this.isApplicationDeniedReasonFilled()) {
                                                                // this.onSubmitApp(e, 'APPROVED');
                                                                this.setState({ modalIsOpen: true });
                                                            } else {
                                                                _addNotificationError("Please provide reason for decline application?", this.props.refNotify);
                                                            }
                                                        } else {
                                                            this.setState({ modalIsOpen: true });
                                                        }

                                                    }}>Confirm</button>
                                                }


                                                <button className="btn btn-xs btn-warning" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {
                                                    this.setState({ incompleteModalIsOpen: true });

                                                }}>{"Incomplete"}</button>

                                                <button className="btn btn-xs btn-info" style={{ margin: '0px 8px 0px 0px' }} onClick={(e) => {
                                                    this.setState({ cancelAppModalIsOpen: true, cancelReason: '' });
                                                }}>
                                                    <Trans>Cancel</Trans>
                                                </button>
                                            </Fragment> : null
                                        }
                                        <button className="btn btn-xs btn-danger" style={{ margin: '0px' }} onClick={(e) => {
                                             if (this.props.isVerificationFlow) {
                                                        this.props.onClose();
                                                    } else {
                                                        this.props.onSubmitChanges("cancel");
                                                    }
                                        }}>{this.props.cancelButtonLable ? this.props.cancelButtonLable : "Close"}</button>
                                           {this.props.enableVerificationSave &&
                                            <button className="btn btn-xs btn-success" style={{ margin: '0px 2px' }} onClick={this.handleVerificationSave} >Save</button> }
                                    </Fragment> :

                                    <button className="btn btn-xs btn-danger" style={{ margin: '0px' }} onClick={(e) => {
                                        this.props.onSubmitChanges("cancel")
                                    }}>{this.props.cancelButtonLable ? this.props.cancelButtonLable : "Close"}</button>

                            }

                        </div>

                    </div>
                </div>
                <Modal isOpen={this.state.cancelAppModalIsOpen}
                    onRequestClose={() => this.setState({ cancelAppModalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className="custom-label col-sm-12 text-left"><Trans>Please enter reason for cancellation</Trans></label>
                            <div className="col-sm-12">
                                <div class="styled-input-container styled-input--square">
                                    <textarea className='form-control' rows="4" value={this.state.cancelReason} onChange={(e) => { this.setState({ cancelReason: e.target.value }) }} ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button className="btn btn-xs btn-success" type="button" onClick={(e) => {
                                this.setState({ cancelAppModalIsOpen: false },
                                    this.onSubmitApp(e, 'CANCELAPP', this.state.appData))
                            }}><Trans>Ok</Trans></button>
                            <button className="btn btn-xs btn-primary" type="button" onClick={(e) => {
                                this.setState({ cancelAppModalIsOpen: false, cancelReason: '' })
                            }}><Trans>Cancel</Trans></button>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.editNoteModalIsOpen}
                    onRequestClose={() => this.setState({ editNoteModalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="row">
                        <div className="col-md-12">
                            <label className="custom-label col-sm-12 text-left"><Trans>Please document why the application was modified.</Trans></label>
                            <div className="col-sm-12">
                                <div class="styled-input-container styled-input--square">
                                    <textarea className='form-control' rows="4" value={this.state.editNote} onChange={(e) => { this.setState({ editNote: e.target.value }) }} ></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <button className="btn btn-xs btn-success" type="button" onClick={(e) => {
                                if ((this.state.editNote || '').trim().length == 0) {
                                    _addNotificationError("Please provide reason for edit content?", this.props.refNotify);
                                    return false;
                                }
                                this.setState({ editNoteModalIsOpen: false }, () => {
                                    this.onSubmitApp(e, 'SAVE', this.state.appData);
                                })
                            }}><Trans>Ok</Trans></button>
                            <button className="btn btn-xs btn-primary" type="button" onClick={(e) => {
                                this.setState({ editNoteModalIsOpen: false, editNote: '' })
                            }}><Trans>Cancel</Trans></button>
                        </div>
                    </div>
                </Modal>

                <Modal isOpen={this.state.modalIsOpen}
                    onRequestClose={() => this.setState({ modalIsOpen: false })}
                    style={modalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="row">
                        <div className="col-md-12">
                            <p>{this.isApplicationIsDenied() ? <Trans>Are you sure you want to decline the student meal status? Once you decline, you are unable to edit the application</Trans> :
                                this.props.enableConfirmingOfficial ? (appData.status == 'pending' ? 'Are you sure you want to determine the student meal status?' :
                                    <Trans>Are you sure you want to confirm the student meal status? once you confirmed, you are unable to edit the application</Trans>) : <Trans>Are you sure you want to approve the student meal status? Once approved, you are unable to edit the application</Trans>
                            }
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            {this.props.enableConfirmingOfficial ? <button className="btn btn-xs btn-success" type="button" onClick={(e) => {

                                if (appData.status == 'pending' || appData.status == 'in-complete') {
                                    if (!confirmingOfficialUserIds.includes(loginUserInfo.userId)) {
                                        const _appdata = { ...this.state.appData };
                                        _appdata.status = 'pending-confirm';
                                        _appdata.determineOfficerUserId = loginUserInfo.userId;
                                        _appdata.determineDate = new Date().toISOString();

                                        this.onSubmitApp(e, "PENDING-CONFIRM", _appdata);
                                    } else {
                                        _addNotificationError("You are not authorized to determine the application status.", this.props.refNotify);
                                        this.setState({ modalIsOpen: false })
                                        return;
                                    }
                                } else if ((appData.status || '').toString().toLowerCase() == 'pending-confirm') {
                                    if (confirmingOfficialUserIds.includes(loginUserInfo.userId)) {
                                        if (appData.determineOfficerUserId == loginUserInfo.userId) {
                                            _addNotificationError("The same user is not allowed to both determine and confirm the application.", this.props.refNotify);
                                            this.setState({ modalIsOpen: false })
                                            return;
                                        }
                                        const _appdata = { ...this.state.appData };
                                        _appdata.status = 'APPROVED';
                                        _appdata.confirmOfficerUserId = loginUserInfo.userId;

                                        _appdata.confirmDate = new Date().toISOString();

                                        this.onSubmitApp(e, "APPROVED", _appdata);

                                    } else {
                                        _addNotificationError("You are not authorized to confirm the application status.", this.props.refNotify);
                                        this.setState({ modalIsOpen: false })
                                        return;
                                    }


                                }
                                this.setState({ modalIsOpen: false })
                                // this.onSubmitApp(e, 'APPROVED'))
                            }}><Trans>Ok</Trans></button> : <button className="btn btn-xs btn-success" type="button" onClick={(e) => {
                                this.setState({ modalIsOpen: false },
                                    this.onSubmitApp(e, 'APPROVED', this.state.appData))
                            }}><Trans>Ok</Trans></button>}
                            <button className="btn btn-xs btn-primary" type="button" onClick={(e) => {
                                this.setState({ modalIsOpen: false })
                            }}><Trans>Cancel</Trans></button>
                        </div>
                    </div>
                </Modal>
                <Modal isOpen={this.state.incompleteModalIsOpen}
                    onRequestClose={() => this.setState({ modalIsOpen: false })}
                    style={reasonModalStyles}
                    contentLabel="Activation"
                    ariaHideApp={false}>
                    <div className="row">
                        <div className="col-xs-12">
                            <IncompleteAppDetails
                                incompleteReasons={[...((this.state.appData || {}).incompleteReasonList || [])]}
                                incompleteDueDate={this.state.appData.incompleteDueDate === undefined ? undefined : moment(this.state.appData.incompleteDueDate)}
                                onReasonSelectionChange={(e, index) => {
                                    const { appData } = this.state;
                                    appData.incompleteReasonList[index].isApplicable = e.target.checked
                                    this.setState({ appData });
                                }}
                                onOtherReasonTextChange={(e, index) => {
                                    const { appData } = this.state;
                                    appData.incompleteReasonList[index].description = e.target.value;
                                    this.setState({ appData });
                                }}
                                onDateChange={(date) => {
                                    const { appData } = this.state;
                                    appData.incompleteDueDate = date;
                                    this.setState({ appData });
                                }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button className="btn btn-xs btn-success" type="button" onClick={(e) => {
                                const { appData } = this.state;
                                if (!(appData.incompleteReasonList || []).some(item => (item.isApplicable))) {
                                    _addNotificationError(<Trans>{`Please select incomplete reason`}</Trans>, this.props.refNotify)
                                    return false;
                                }
                                if ((appData.incompleteReasonList || []).some(item => (item.name === 'Other:' && item.isApplicable && (item.description || '').length === 0))) {
                                    _addNotificationError(<Trans>{`Please enter other reason`}</Trans>, this.props.refNotify)
                                    return false;
                                }
                                if (!appData.incompleteDueDate) {
                                    _addNotificationError(<Trans>{`Select due date to receive missing information`}</Trans>, this.props.refNotify)
                                    return false;
                                }
                                this.onSubmitApp(e, 'incomplete', this.state.appData);

                            }}><Trans>Submit</Trans></button>
                            <button className="btn btn-xs btn-primary" type="button" onClick={(e) => {
                                this.setState({ incompleteModalIsOpen: false })
                            }}><Trans>Cancel</Trans></button>
                        </div>
                    </div>
                </Modal>
                 <Modal
                    isOpen={this.state.conformationModalIsOpen}
                    onRequestClose={() => this.setState({ conformationModalIsOpen: false, pendingUpdateType: null, pendingUpdateData: null, eligModalIsOpen: false, eligFreeClicked: undefined, freeEligibleReason: '' })}
                    style={modalStyles}
                    contentLabel="Confirmation">
                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="conformationLabel">Confirmation</h4>
                    </div>
                    <div className="modal-body">
                        <p>"This will notify the student's parent/guardian of this change. The student will continue to receive their original benefits for the next 10 operating days. If the parent/guardian files an appeal, update the status for the student under Claims Reports → Adverse Action"</p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-sm"
                            onClick={() => this.setState({ conformationModalIsOpen: false, pendingUpdateType: null, pendingUpdateData: null, eligModalIsOpen: false, eligFreeClicked: undefined, freeEligibleReason: '' })}
                            style={{ margin: 0, fontSize: 14 }}> Cancel
                        </button>
                        <button id="confirmEligibilityChange" type="button" className="btn btn-success btn-sm"
                            onClick={() => {
                                const { pendingUpdateData } = this.state;
                                this.setState({ conformationModalIsOpen: false, pendingUpdateType: null, pendingUpdateData: null, eligModalIsOpen: false, eligFreeClicked: undefined, freeEligibleReason: '' });
                                if (pendingUpdateData && pendingUpdateData.action && pendingUpdateData.appData) {
                                    this.onSubmitApp(null, pendingUpdateData.action, pendingUpdateData.appData, true);
                                }
                            }}
                            style={{ margin: 0, marginLeft: 5, fontSize: 14 }}>
                            Confirm</button>
                    </div>
                </Modal>
            </section>
        )
    }
}
export default translate("translations")(SchoolMealProgramView);



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/schoolMealProgramView.jsx